import React from 'react';
import styles from './productSkeleton.module.css';

interface Props {
  color?: string;
}
export default function ProductSkeleton({ color = 'var(--background-default)' }: Props) {
  return <div className={`${styles.skeletonItem} rounded`} style={{ backgroundColor: color }} />;
}
